import { render, staticRenderFns } from "./none.vue?vue&type=template&id=18016172&"
import script from "./none.vue?vue&type=script&lang=js&"
export * from "./none.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports